"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InventoryState = void 0;
var InventoryState;
(function (InventoryState) {
    InventoryState["SELLABLE"] = "Sellable";
    InventoryState["DAMAGED"] = "Damaged";
    InventoryState["ON_HOLD"] = "On Hold";
    InventoryState["OTHER"] = "Other";
    InventoryState["QUARANTINE"] = "Quarantine";
    InventoryState["QUARANTINE_RECALL"] = "Quarantine Recall";
    InventoryState["EXPIRED"] = "Expired";
    InventoryState["MISSING"] = "Missing";
    InventoryState["RECEIVING"] = "Receiving";
    InventoryState["RETURNS"] = "Returns";
    InventoryState["RESERVE"] = "Reserve";
    InventoryState["LOCKED"] = "Locked";
})(InventoryState = exports.InventoryState || (exports.InventoryState = {}));
//# sourceMappingURL=InventoryState.js.map